import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

const lang = localStorage.getItem('locale') || 'zh'
if (lang === 'en') {
  locale.use(enLocale)
} else {
  locale.use(zhLocale)
}

Vue.use(ElementUI)
